import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { useMeilisearch } from 'src/hooks/meilisearch/use-meilisearch';
import { useUserStore } from 'src/store/user-store';
import { fetchSpaces } from '../lib/spaces';
import { spacesKeys } from '../query-keys/spaces';

export const useSpacesBySpaceGroupTokens = (tokens: string[]) => {
  const { directoryToken } = useUserStore();

  const searchState: SearchState = {
    filter: [tokens.map(token => `spaceGroupToken = ${token}`) ?? []],
    q: '',
    sort: [],
  };

  const query = useMeilisearch({
    fetch: fetchSpaces,
    queryKey: spacesKeys.list(
      directoryToken!,
      1,
      // TODO: temporary fix to get as much spaces as we can
      1000,
      // tokens.length,
      searchState,
    ),
    page: 1,
    // TODO: temporary fix to get as much spaces as we can
    perPage: 1000,
    searchState,
    enabled: tokens.length > 0,
  });

  return query;
};
